<script setup>
    import { useStageStore } from '@/stores/stage';

    const formStorage = useStageStore();

    const props = defineProps({
        stage: Object
    })

    const getPathTypeValues = (currentQuestionPathTypeId) => {
        const currentPathType = formStorage.pointsPerPathType.filter(obj => (obj.id === currentQuestionPathTypeId));
        return currentPathType;
    }
</script>

<template>
    <div class="total-points">

        <div
            v-if="stage?.ancestors?.length === 0"
            class="points-container all-paths"
        >
            <div class="current-points">
                <span class="value-points">{{ formStorage.totalPoints }}</span>
                <span class="text-points">{{ $t('points') }}</span>
            </div>
            <div class="survey-max-points mt-2">
                <span class="value-points">{{ formStorage.stagesData?.data?.surveyMaxPointsPossible }}</span>
                <span class="text-points">{{ $t('survey-max-points') }}</span>
            </div>
        </div>

        <div
            v-else 
            v-for="pathType in getPathTypeValues(stage.node.pathType)" 
            :key="pathType.id" 
            :class="`points-container single-path path-${pathType.id}`"
        >
            <div class="current-points">
                <span class="value-points">{{ pathType.points }}</span>
                <span class="text-points">{{ $t('points') }}</span>
            </div>
            <div class="max-points mt-2">
                <span class="value-points">{{ pathType.maxPoints }}</span>
                <span class="text-points">{{ $t('survey-max-points') }}</span>
            </div>
        </div>
    </div>
</template>